import HeroContainer from "../features/Hero/HeroContainer";
import HeroWrapper from "../components/Wrappers/HeroWrapper";

const Hero = () => {
  return (
    <HeroWrapper>
      <HeroContainer />
    </HeroWrapper>
  );
};

export default Hero;
